import { render, staticRenderFns } from "./CreateFreelance.vue?vue&type=template&id=5990c140&scoped=true"
import script from "./CreateFreelance.vue?vue&type=script&lang=js"
export * from "./CreateFreelance.vue?vue&type=script&lang=js"
import style0 from "./CreateFreelance.vue?vue&type=style&index=0&id=5990c140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5990c140",
  null
  
)

export default component.exports